import { cn, FormatUtils, PaletteUtils } from '@shared/utils';
import type { RecipientResponse } from '@shared/api';
import { Text } from '@shared/widgets';

interface RecipientInfoProps {
  className?: string;
  recipient: RecipientResponse;
}

export const RecipientInfo = (props: RecipientInfoProps) => {
  return (
    <section className={cn('flex flex-col gap-6', props.className)}>
      <div
        className={cn('flex gap-2 bg-white p-4 dark:bg-soft-black', PaletteUtils.isVcfcPalette && 'rounded-xl dark:border dark:border-gray-black')}
      >
        <div className='flex h-12 w-12 items-center justify-center bg-black'>
          <Text className='' weight='semibold' size='xl' color='white'>
            {FormatUtils.getRecipientInitials(props.recipient)}
          </Text>
        </div>
        <div>
          <Text weight='semibold' size='xl'>
            {FormatUtils.getRecipientName(props.recipient)}
          </Text>
          <Text uppercase weight='semibold' size='xs' color='gray'>
            {props.recipient.iban || props.recipient.accountNumber || '-'}
          </Text>
        </div>
      </div>
    </section>
  );
};
